import axios from "axios";
import * as actionType from "../../../constant/actionType";

/*** GenerateClientSitesReport Action ***/
export const GenerateClientSitesReportStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.GenerateClientSitesReport_START,
    };
};
export const GenerateClientSitesReportSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.GenerateClientSitesReport_SUCCESS,
    };
};
export const GenerateClientSitesReportFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.GenerateClientSitesReport_FAIL,
    };
};

export const GenerateClientSitesReport = ({
    filterpage,
    filterlimit,
    filtersort,
    filterorder,
    filterStatus,
    client_org_ids,
    date_range,
    siteIds,
    stateIds
}) => {
    return (dispatch) => {
        dispatch(GenerateClientSitesReportStart());

        const config = {
            method: "get",
            url: `${actionType.environment_url}/api/admin/GenerateClientSitesReport`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
            },
            params: {
                limit: filterlimit,
                page: filterpage,
                sort: filtersort,
                order: filterorder,
                is_active: filterStatus,
                client_org_ids: JSON.stringify(client_org_ids),
                created_date_range:date_range,
                site_ids: JSON.stringify(siteIds),
                state_ids: JSON.stringify(stateIds),
            },
        };

        return axios(config)
            .then(function (response) {
                dispatch(GenerateClientSitesReportSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(
                    GenerateClientSitesReportFail("Something went wrong, Please try again.")
                );
                return error;
            });
    };
};